(()=>{
    function initLanguageSwitcher(container) {
        const trigger = container.querySelector('[data-language-switcher-trigger]');
        const menu = container.querySelector('[data-language-switcher-menu]');
        if (!trigger || !menu) return;
        const links = Array.from(menu.querySelectorAll('a[href]'));
        let isOpen = false;
        function setOpen(open) {
            isOpen = open;
            trigger.setAttribute('aria-expanded', String(open));
            menu.setAttribute('aria-hidden', String(!open));
            menu.toggleAttribute('inert', !open);
            menu.classList.toggle('is-open', open);
        }
        function close(restoreFocus = false) {
            setOpen(false);
            if (restoreFocus) trigger.focus();
        }
        trigger.addEventListener('click', ()=>{
            setOpen(trigger.getAttribute('aria-expanded') !== 'true');
        });
        trigger.addEventListener('keydown', (event)=>{
            if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
            event.preventDefault();
            setOpen(true);
            const link = event.key === 'ArrowDown' ? links[0] : links[links.length - 1];
            link?.focus();
        });
        container.addEventListener('keydown', (event)=>{
            if (event.key !== 'Escape' || !isOpen) return;
            event.preventDefault();
            event.stopPropagation();
            close(true);
        });
        menu.addEventListener('click', (event)=>{
            const target = event.target;
            if (target instanceof Element && target.closest('a[href]')) close();
        });
        document.addEventListener('click', (event)=>{
            const target = event.target;
            if (target instanceof Node && !container.contains(target)) close();
        });
        window.addEventListener('pageshow', ()=>close());
        setOpen(false);
    }
    function init() {
        document.querySelectorAll('[data-language-switcher]').forEach(initLanguageSwitcher);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();

//# sourceMappingURL=language-switcher.55cd66ef.js.map
